
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ContactInfoSectionProps {
  email: string;
  mobile: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ContactInfoSection = ({ email, mobile, onChange }: ContactInfoSectionProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="email">Email Address *</Label>
        <Input 
          id="email" 
          name="email" 
          type="email" 
          value={email} 
          onChange={onChange} 
          required 
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="mobile">Mobile Number *</Label>
        <Input 
          id="mobile" 
          name="mobile" 
          type="tel" 
          value={mobile} 
          onChange={onChange} 
          required 
        />
      </div>
    </div>
  );
};

export default ContactInfoSection;
